import React, { useState } from 'react'
import Pagination from '@mui/material/Pagination';


const PaginationComp = ({pageCount, setPageNumber, paramsPage}) => {
  let page = JSON.parse(sessionStorage.getItem('pageNumber')) ? JSON.parse(sessionStorage.getItem('pageNumber')) : 0
  return (
      <div
        style={{
          display: 'flex',
          height: '200px',
          width: '100%',
          justifyContent: 'center',
          alignItems: 'center',
      }}
      >
        <Pagination 
          style={{
            display: 'flex',
            justifyContent: 'center'
          }}
          variant="outlined" 
          color="primary"
          count={pageCount}
          defaultPage={page + 1}
          showFirstButton={true}
          showLastButton={true}
          hideNextButton={true}
          hidePrevButton={true}
          onChange={(e, value) => {
            console.log(
              "value is", value
            )
              window.scroll(0,0)
              setPageNumber(value - 1)
            }
          }
          />
      </div>
  )
}

export default PaginationComp